"use strict";
var ModalOptions = (function () {
    function ModalOptions() {
        this.continueButtonText = 'Continue';
    }
    return ModalOptions;
}());
exports.ModalOptions = ModalOptions;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/misc/modals/modal-options.model.js